<template>
  <div class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">
        {{ route.params.id ? 'Editar Convênio' : 'Novo Convênio' }}
      </h4>
      <button class="btn btn-secondary btn-sm me-3" @click="voltar">Voltar</button>
    </div>

    <BaseForm :isFormValid="isFormValid" :isSubmitting="isSubmitting" @submit="salvarConvenio" @cancel="voltar">
      <!-- Dados do Convênio -->
      <FormSection title="Informações do Convênio">
        <InputField
          v-model="convenio.nome"
          label="Nome do Convênio <span class='required'>*</span>"
          id="nome"
          placeholder="Digite o nome do convênio"
          required
          :class="{ 'error-input': false }"
          width="400px"
        />

        <InputField
          v-model="convenio.desconto"
          label="Desconto (%) <span class='required'>*</span>"
          id="desconto"
          placeholder="Digite o percentual de desconto"
          required
          type="number"
          :class="{ 'error-input': false }"
        />

        <div class="form-group">
          <label for="ativo">Status <span class="required">*</span></label>
          <div class="form-switch">
            <input
              type="checkbox"
              id="ativo"
              v-model="convenio.ativo"
              class="form-check-input"
            />
            <label for="ativo" class="form-check-label">
              {{ convenio.ativo ? "Ativo" : "Inativo" }}
            </label>
          </div>
        </div>
      </FormSection>
    </BaseForm>
  </div>
</template>
        
<script>
import { reactive, ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import InputField from '@/components/Layout/InputField.vue';
import FormSection from '@/components/Layout/FormSection.vue';
import BaseForm from '@/components/Layout/BaseForm.vue';
import axios from '@/services/axios';

export default {
  components: { InputField, FormSection, BaseForm },
  setup() {
    const route = useRoute();
    const router = useRouter();

    const convenio = reactive({
      id: null,
      nome: "",
      desconto: null,
      ativo: true, // Valor padrão para o status
    });

    // Se não for mais necessária a exibição de erros, você pode remover ou não utilizá-los
    // const errors = reactive({});
    // const formTouched = ref(false);
    const isSubmitting = ref(false);

    // Propriedade computada que verifica se todos os campos obrigatórios estão preenchidos
    const isFormValid = computed(() => {
      return (
        convenio.nome.trim() !== '' &&
        convenio.desconto !== null &&
        convenio.desconto !== '' &&
        convenio.desconto >= 0 &&
        convenio.desconto <= 100
      );
    });

    const novoConvenio = () => {
      // formTouched.value = false;
      isSubmitting.value = false;
      Object.assign(convenio, {
        nome: '',
        desconto: null,
        ativo: true,
      });
      // Se estiver usando errors, pode limpá-los aqui
    };

    const salvarConvenio = async () => {
      if (isSubmitting.value) return;

      // Se desejar, mantenha a validação interna, mas sem exibir mensagens ao usuário
      if (!isFormValid.value) {
        console.error("Formulário inválido");
        return;
      }

      isSubmitting.value = true;
      try {
        const method = convenio.id ? "put" : "post";
        const url = convenio.id
          ? `/cadastros/convenios/${convenio.id}`
          : "/cadastros/convenios";

        await axios[method](url, {
          nome: convenio.nome,
          desconto: parseFloat(convenio.desconto),
          ativo: convenio.ativo,
        });

        router.push("/cadastros/convenios");
      } catch (error) {
        console.error("Erro ao salvar convênio:", error);
      } finally {
        isSubmitting.value = false;
      }
    };

    const voltar = () => {
      router.push('/cadastros/convenios');
    };

    onMounted(async () => {
      const convenioId = route.params.id;
      if (convenioId) {
        try {
          const response = await axios.get(
            `/cadastros/convenios/${convenioId}`
          );
          Object.assign(convenio, response.data);
        } catch (error) {
          console.error('Erro ao carregar convênio:', error);
        }
      } else {
        novoConvenio();
      }
    });

    return {
      convenio,
      isFormValid,
      isSubmitting,
      salvarConvenio,
      voltar,
      route,
    };
  },
};
</script>
        
<style scoped>
.card {
  max-width: 90%;
  margin: 0 auto;
}

.error-input {
  border-color: #dc3545;
}

.error-message {
  color: #dc3545;
  font-size: 0.875rem;
}
.form-switch {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
